<template>
    <div class='component-page'>
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                <span>时间：</span>
                <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                <span style="margin: 0 10px;">至</span>
                <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="2" style="float:right">
                <i-button type="primary" icon="md-add" shape="circle" @click="add_new">添加</i-button>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
            <Modal v-model="addModel" width="720" :title="modalTitle">
                <div v-if='addModel'>
                    <Form ref="formData" :model="formData" :rules="userRule" label-position="top">
                        <Row>
                            <Col span="20">
                            <FormItem label="标题" prop='title'>
                                <Input v-model="formData.title" type="text" placeholder="请输入..."></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                            <FormItem label="轮播图顺序" prop='sort'>
                                <Input v-model="formData.sort" type="text" placeholder="请输入..."></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row v-if='addModel'>
                            <FormItem label="活动banner图" prop="cover_url">
                                <Upload @getPicList="getPicList" :getList='formData.cover_url' message='1' id='cover'></Upload>
                            </FormItem>
                        </Row>
                        <FormItem label="banner类型" prop="position">
                            <Radio-group v-model="formData.position">
                                <Radio label="1">首页banner</Radio>
                                <Radio label="2">精品课堂</Radio>
                                <Radio label="3">名师在线</Radio>
                                <Radio label="4">每日跟我弹</Radio>
                                <Radio label="5">游学</Radio>
                                <Radio label="6">音乐汇</Radio>
                                <Radio label="7">课程列表banner</Radio>

                            </Radio-group>
                        </FormItem>
                        <FormItem label="类型" prop="type">
                            <Radio-group v-model="formData.type">
                                <Radio label="2">老师端</Radio>
                                <Radio label="1">学生端</Radio>
                            </Radio-group>
                        </FormItem>
                        <FormItem label="跳转类型" prop="jump_type" v-if='formData.position==1'>
                            <Radio-group v-model="formData.jump_type">
                                <Radio label="1">h5</Radio>
                                <Radio label="2">课程</Radio>
                                <Radio label="3">无跳转</Radio>
                            </Radio-group>
                        </FormItem>
                        <FormItem label="h5地址" prop='h5_url' v-if='formData.jump_type==1'>
                            <Input v-model="formData.h5_url" type="text" placeholder="请输入..."></Input>
                        </FormItem>
    
                        <FormItem label="课程" prop='lesson_id' v-if='formData.jump_type==2'>
                            <Select filterable v-model="formData.lesson_id" style='width:300px;' clearable>
                                <Option v-for="item in classList" :value="item.lesson_id" :key="item.lesson_id">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        
                    </Form>
                </div>
                <div slot="footer">
                    <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                    <Button type="primary" shape="circle" @click="add_edit('formData')">确定</Button>
                </div>
            </Modal>
            <Modal v-model="remindModal" width="440" @on-cancel='cancel' class='remind'>
                <div class='remindContent'>
                    {{remindContent}}
                </div>
                <div slot="footer">
                    <Button type='primary' ghost shape="circle" @click='cancel'>取消</Button>
                    <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>

<script>
    import moment from 'moment'
    import {
        fetchTableList,
        setDel,
        addModify,
        fetchInfo,
       
    } from '@/api/bannerList'
    import {
        fetchLessonList,
    } from '@/api/common'
    import Upload from '../common/picture.vue'
    
    export default {
        name: 'user-components',
        components: {
            Upload
        },
        data() {
            return {
                total_count: 0, //列表总条数
                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                },
                start_time: '',
                end_time: '',
                banner_id: '',
                modalTitle: '添加',
                remindModal: false,
                addModel: false, //添加老师
                formData: {
                    banner_id: '',
                    title: '',
                    sort: '',
                    cover_url: '',
                    jump_type: '',
                    position: '',
                    h5_url: '',
                    lesson_id: '',
                    type:'',
                },
                classList:[],
                remindContent: '',
                userRule: {
                    title: [{
                        required: true,
                        message: '不能为空'
                    }],
                    sort: [{
                        required: true,
                        message: '不能为空'
                    }],
                    cover_url: [{
                        required: true,
                        message: '不能为空'
                    }],
                    jump_type: [{
                        required: true,
                        message: '不能为空'
                    }],
                    type: [{
                        required: true,
                        message: '不能为空'
                    }],
                    position: [{
                        required: true,
                        message: '不能为空'
                    }],
    
                }, //
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
    
                    },
                    {
                        title: '标题',
                        align: 'center',
                        key: 'title',
    
                    },
                    {
                        title: '图片',
                        align: 'center',
                        key: 'cover_url',
                        width: 100,
                        render: (h, params) => {
                            return h("img", {
                                attrs: {
                                    src: params.row.cover_url
                                },
                                style: {
                                    width: '60px',
                                    height: '60px',
                                    marginTop: '4px'
                                }
                            })
    
    
                        }
                    },
    
                    {
                        title: '排序',
                        align: 'center',
                        key: 'sort',
                    },
                    {
                        title: '跳转类型',
                        align: 'center',
                        key: 'jump_type',
                        render(h, params) {
                            if (params.row.jump_type == 1) {
                                return h('span', 'h5');
                            } else if (params.row.jump_type == 2) {
                                return h('span', '课程');
                            } else {
                                return h('span', '不跳转');
                            }
                        }
                    },
                    {
                        title: '跳转链接',
                        align: 'center',
                        key: 'h5_url',
                        render(h, params) {
                            if (params.row.h5_url != '') {
                                return h('span', params.row.h5_url);
                            } else {
                                return h('span', '空');
                            }
                        }
                    },
                    {
                        title: '展示位置',
                        align: 'center',
                        key: 'position',
                        render(h, params) {
                            if (params.row.position == 1) {
                                return h('span', '首页banner');
                            } else if (params.row.position == 2) {
                                return h('span', '精品课堂');
                            } else if (params.row.position == 3) {
                                return h('span', '名师在线');
                            } else if (params.row.position == 4) {
                                return h('span', '每日跟我弹');
                            } else if (params.row.position == 5) {
                                return h('span', '游学');
                            } else if (params.row.position == 6) {
                                return h('span', '音乐汇');
                            } else {
                                return h('span', '课程列表banner');
                            }
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    style: {
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row.banner_id)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.banner_id)
                                        }
                                    }
                                }, '删除'),
                            ])
                        }
                    },
    
                ], //列表标题
    
                editIncellData: [], //列表数据
    
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            //   this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getClassList(){
                fetchLessonList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.classList = res.data;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            edit(id) {
                fetchInfo({
                    banner_id: id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.modalTitle = '修改';
                        this.formData = res.data;
                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            add_edit(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.formData.page = 1;
                                this.getData();
                                this.addModel = false;
                            } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                        name: 'login'
                                    })
                                })
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
    
                    }
                })
            },
            // 添加老师
            add_new() {
                this.formData.banner_id = '';
                this.formData.title = '';
                this.formData.sort = '';
                this.formData.cover_url = '';
                this.formData.jump_type = '';
                this.formData.position = '';
                this.formData.h5_url = '';
                this.formData.lesson_id = '';
                this.formData.type = '';

                this.modalTitle = '新增';
                this.addModel = true;
            },
            delete(id) {
                this.banner_id = id;
                this.remindContent = '确定删除该banner吗？';
                this.remindModal = true;
            },
            primaryRemind() {
                setDel({
                    banner_id: this.banner_id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formItem.page = 1;
                        this.getData();
                        this.remindModal = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getPicList(picList) {
                this.formData.cover_url = picList[0].url.split('.com')[1];
            },
            cancel() {
                this.remindModal = false;
                this.addModel = false;
    
            },
            // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
            //跳转制定页码
            jumpPage(row) {
                this.formItem.page = row;
                this.getData();
            },
            //改变每页条数
            changePageSize(row) {
                this.formItem.page_size = row;
                this.formItem.page = 1;
                this.getData();
            }
    
        },
        mounted() {
            this.getData();
            this.getClassList();
    
        },
    };
</script>
